<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/chiliu0007#acknow">Acknowledgments</a></p>
<p class="toc"><a class="xref" href="#/chiliu0008#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/chiliu0009#ch01">1  Friending the Past</a></p>
<p class="toc"><a class="xref" href="#/chiliu0010#ch02">2  Imagining the New Media Encounter</a></p>
<p class="toc"><a class="xref" href="#/chiliu0011#ch03">3  When Was Linearity?</a></p>
<p class="toc"><a class="xref" href="#/chiliu0012#ch04">4  Remembering Networks</a></p>
<p class="toc"><a class="xref" href="#/chiliu0013#ch05">5  Like a Sense of History</a></p>
<p class="tocbmf"><a class="xref" href="#/chiliu0014#app">Appendix: Hypothetical Machine-Learning Workflow for Studying the Sense of History</a></p>
<p class="tocbm"><a class="xref" href="#/chiliu0015#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chiliu0017#wrk_ctd">Works Cited</a></p>
<p class="tocbm"><a class="xref" href="#/chiliu0018#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-liu-0006.vue?dfdde1b6